import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from '../../../../../adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from '../../../../../adapters/types'
import { DischargeFormData } from '../../../../types/formData'
import { DischargeFormField } from '../../../../types/formField'
import { DischargeAssessmentQuestionnaireItem } from '../../../../types/questionnaire'
import { getAnswerValuesFromItems } from '../../../../../helpers'

/**
 * Cardiac subsection adapter
 * Handles cardiovascular assessment and heart sounds (4 fields)
 */
export class CardiacAdapter extends BaseSubsectionAdapter<DischargeFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<DischargeFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    // Cardiac assessment fields
    const cardiacStatus = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_WNL
    )?.at(0)

    const cardiacAbnormalFactors = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_FACTORS
    )

    const heartSounds = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_HEART_SOUNDS
    )?.at(0)

    const systemSummary = getAnswerValuesFromItems(
      flatAnswersArray,
      DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_SYSTEM_SUMMARY
    )?.at(0)

    return {
      [DischargeFormField.CARDIAC_STATUS]: cardiacStatus,
      [DischargeFormField.CARDIAC_ABNORMAL_FACTORS]: cardiacAbnormalFactors,
      [DischargeFormField.CARDIAC_HEART_SOUNDS]: heartSounds,
      [DischargeFormField.CARDIAC_SYSTEM_SUMMARY]: systemSummary
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    if (this.formDataFieldExists(DischargeFormField.CARDIAC_STATUS)) {
      mutations.push({
        linkId: DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_WNL,
        value: this.getFormDataField(DischargeFormField.CARDIAC_STATUS)
      })
    }
    if (this.formDataFieldExists(DischargeFormField.CARDIAC_ABNORMAL_FACTORS)) {
      mutations.push({
        linkId:
          DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_CARDIOVASCULAR_FACTORS,
        value: this.getFormDataField(DischargeFormField.CARDIAC_ABNORMAL_FACTORS)
      })
    }
    if (this.formDataFieldExists(DischargeFormField.CARDIAC_HEART_SOUNDS)) {
      mutations.push({
        linkId: DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_HEART_SOUNDS,
        value: this.getFormDataField(DischargeFormField.CARDIAC_HEART_SOUNDS)
      })
    }
    if (this.formDataFieldExists(DischargeFormField.CARDIAC_SYSTEM_SUMMARY)) {
      mutations.push({
        linkId: DischargeAssessmentQuestionnaireItem.MEDICAL_BACKGROUND_CARDIAC_SYSTEM_SUMMARY,
        value: this.getFormDataField(DischargeFormField.CARDIAC_SYSTEM_SUMMARY)
      })
    }

    return mutations
  }
}
